import React from 'react';

const Header = ({children}) => (
  <header>{children}</header>
);

export default Header;
